import React, { useEffect, useMemo } from 'react'
import Form from 'tyan/public/components/Form'
import { useInstData } from 'tyan/public/hooks'

const ViewFile = props => {
	let { id: idProps, match: { params: { id } } } = props

	const { me, setState, me: { state: { file: { FID } = {}, initValuesBasic: { pdf } = {} } } } = useInstData(props)

	useEffect(() => {
		let data
		try {
			const value = sessionStorage[`viewFile${id}`]
			sessionStorage.removeItem(`viewFile${id}`)
			data = JSON.parse(value)
		} catch (ex) {
			window.close()
			setTimeout(() => alert('无效链接，请关闭窗口'), 100)
		}

		if (!data) {
			return
		}

		const { comments, ...file } = data

		setState({ file, initValuesBasic: { pdf: comments } })
	}, [])

	const fieldsetBasic = useMemo(() => [{
		_pdf: '', name: 'pdf', FID, commentsEnabled: !!pdf, commentsEditable: false
	}], [FID, pdf])

	return FID
		? <Form data={me} shadow={false} fullForm
			fieldsets={
				[
					{ title: '', name: 'Basic', _fieldset: fieldsetBasic, fullblock: true }
				]
			}
		/>
		: null
}

export default ViewFile